import router from '@/router/index';
import { Message, MessageBox } from 'element-gui';
import service from '@/request/service';
import toolbar from './toolbar';
import layer from '@/dialog/layer';
import { LAYER_URL } from '../../utils/baseUrl';
var flagLoading = 0;
const state = {
  userInfo: '', // 用户信息
  list: [],
  currentBidSection: '',
  faildReason: '',
  isFailBid: false, //确认流标
  crDialogVisible: false, //确认加解密
  isCloseEndLoading: false, // 关闭开标结束loading
};
const getters = {
  userName: (state) => state.userInfo.userName || '',
};
const actions = {
  // 获取项目开标结束信息
  getOpenBidFinishInfo({ commit }) {
    service
      .post('/openbidFinish/getOpenBidFinishInfo', {
        domainID: JSON.parse(sessionStorage.getItem('row'))[0].domainId,
        projectId: JSON.parse(sessionStorage.getItem('row'))[0].projectId,
        stage: JSON.parse(sessionStorage.getItem('currentMenuTrue')).stage,
        userCode: JSON.parse(sessionStorage.getItem('obj')).userId,
        roleType: JSON.parse(sessionStorage.getItem('obj')).userType,
      })
      .then(({ data, code, msg }) => {
        if (code !== 200) {
          MessageBox({
            title: '提示',
            message: msg,
            type: 'error',
          });
          return;
        }
        commit('LIST', data);
      });
  },
  //执行开标结束流程
  handleEnd({ dispatch, commit }, payload) {
    flagLoading++;
    commit('CURRENTBIDSECTION', payload);
    sessionStorage.setItem('openbidStage', payload.openbidStage);
    if (flagLoading === 1) {
      if (payload.openbidStage === 1 || payload.openbidStage === 0) {
        //第一阶段或无阶段
        if (payload.bidResult === 0) {
          //  未流标 -- 下一步检测是否完成解密、解析、异议
          dispatch('checkDecryptAndParseAndDissentFinish', payload);
        } else {
          // 已流标
          dispatch('checkOpenReportSign');
        }
      } else if (payload.openbidStage === 2) {
        //第二阶段
        if (payload.bidResult === 0) {
          //  未流标 -- 下一步检测是否完成异议
          dispatch('checkDissentFinish');
        } else {
          // 已流标
          dispatch('checkOpenReportSign');
        }
      }
    }
  },
  // 是否需要确认流标
  failBidsVisible({ state, dispatch, commit }) {
    commit('SETCLOSELOADING', false);  // 关闭开标结束loading
    service
      .post('/openbidFinish/failBidsVisible', {
        bidSectionId: state.currentBidSection.bidSectionId,
        openbidId: state.currentBidSection.openbidId,
        openBidStage: state.list[0].openbidStage,
      })
      .then((data) => {
        if (data.code === 200) {
          if (data.data.failBidsVisibleState) {
            commit('SETCLOSELOADING', true);  // 关闭开标结束loading
            MessageBox({
              title: '提示',
              message:
                '当前标段 ' +
                state.currentBidSection.bidSectionName +
                ' 有效投标单位家数小于' +
                data.data.candidateCount +
                '家，确定要流标？',
              showCancelButton: true,
              cancelButtonText: '继续',
              confirmButtonText: ' 流标',
              cancelButtonClass: 'confirmButton confirmButtonFailBid',
              confirmButtonClass: 'cancelButton',
              closeOnClickModal: false,
              closeOnPressEscape: false,
              distinguishCancelAndClose: true,
            })
              .then(() => {
                // 需要流标
                commit('ISFAILBID', true);
              })
              .catch((action) => {
                if (action == 'cancel') {
                  if (
                    state.currentBidSection.openbidStage === 1 ||
                    state.currentBidSection.openbidStage === 0
                  ) {
                    dispatch('checkOpenReportSign');
                  } else if (state.currentBidSection.openbidStage === 2) {
                    dispatch('checkEvaluBenchmarkPrice');
                  }
                }
              });
          } else {
            if (
              state.currentBidSection.openbidStage === 1 ||
              state.currentBidSection.openbidStage === 0
            ) {
              dispatch('checkOpenReportSign');
            } else if (state.currentBidSection.openbidStage === 2) {
              dispatch('checkEvaluBenchmarkPrice');
            }
          }
        } else {
          commit('SETCLOSELOADING', true);  // 关闭开标结束loading
          MessageBox({
            title: '提示',
            message: data.msg,
            showCancelButton: true,
            cancelButtonText: '继续',
            confirmButtonText: ' 流标',
            cancelButtonClass: 'confirmButton confirmButtonFailBid',
            confirmButtonClass: 'cancelButton',
            closeOnClickModal: false,
            closeOnPressEscape: false,
            distinguishCancelAndClose: true,
          });
        }
        setTimeout(() => {
          flagLoading = 0;
        }, 500);
      })
      .catch(() => {
        setTimeout(() => {
          flagLoading = 0;
        }, 500);
      });
  },
  //流标接口
  failBid({ rootState, state, commit, dispatch }) {
    service
      .get('/openBid/info/getOpenbidStage', {
        params: {
          domainId: rootState.openbidProject.currentBidSection.domainId,
        },
      })
      .then((result) => {
        if (result.code == 200) {
          service
            .post('/failBid/failBid', {
              bidResult: '1',
              bidSectionId: state.currentBidSection.bidSectionId,
              faildReason: state.faildReason,
              openBidStage: state.currentBidSection.openbidStage,
              projectId: state.currentBidSection.projectId,
              failBidNode: result.data == 2 ? 'secondBidOpen' : 'decryptEnd',
            })
            .then((res) => {
              if (res.code == 200) {
                commit('ISFAILBID', false);
                commit('FAILDREASON', '');
                dispatch('getOpenBidFinishInfo');
              } else {
                MessageBox({
                  title: '提示',
                  message: res.msg,
                  showCancelButton: true,
                  cancelButtonText: '取消',
                  confirmButtonText: '确认',
                  cancelButtonClass: 'confirmButton confirmButtonFailBid',
                  confirmButtonClass: 'cancelButton',
                  closeOnClickModal: false,
                  closeOnPressEscape: false,
                  distinguishCancelAndClose: true,
                });
              }
            });
        }
      });
  },
  //校验开标记录表是否生成及签章
  checkOpenReportSign({ dispatch,commit }) {
    service
      .get('/openbidFinish/checkOpenReportSign', {
        params: {
          bidSectionId: state.currentBidSection.bidSectionId,
          openbidId: state.currentBidSection.openbidId,
          userId: JSON.parse(window.sessionStorage.getItem('obj')).userId,
        },
      })
      .then((data) => {
        commit('SETCLOSELOADING', true);  // 关闭开标结束loading
        if (data.code === 200) {
          // 开标结束
          MessageBox({
            title: '提示',
            message: '确认开标结束？',
            showCancelButton: true,
            cancelButtonText: '取消',
            confirmButtonText: '确认',
            cancelButtonClass: 'confirmButton confirmButtonFailBid',
            confirmButtonClass: 'cancelButton',
            closeOnClickModal: false,
            closeOnPressEscape: false,
            distinguishCancelAndClose: true,
          })
            .then(() => {
              //确认开标结束
              dispatch('doOpenBidFinish');
              setTimeout(() => {
                flagLoading = 0;
              }, 500);
            })
            .catch(() => {
              // 取消
              setTimeout(() => {
                flagLoading = 0;
              }, 500);
            });
        } else {
          MessageBox({
            title: '提示',
            message: data.msg,
            showCancelButton: true,
            cancelButtonText: '取消',
            confirmButtonText: '确认',
            cancelButtonClass: 'confirmButton confirmButtonFailBid',
            confirmButtonClass: 'cancelButton',
            closeOnClickModal: false,
            closeOnPressEscape: false,
            distinguishCancelAndClose: true,
          })
            .then(() => {
              // 自动打开开标结果辅助功能弹框、
              dispatch('handleKbjg');
              setTimeout(() => {
                flagLoading = 0;
              }, 500);
            })
            .catch(() => {
              //取消
              setTimeout(() => {
                flagLoading = 0;
              }, 500);
            });
        }
      })
      .catch(() => {
        commit('SETCLOSELOADING', true);  // 关闭开标结束loading
        setTimeout(() => {
          flagLoading = 0;
        }, 500);
      });
  },
  // 检测是否完成解密，异议
  checkDecryptAndParseAndDissentFinish({ dispatch ,commit}, payload) {
    service
      .get('/openbidFinish/checkDecryptAndParseAndDissentFinish', {
        params: {
          openbidId: state.currentBidSection.openbidId,
          jump: 'decrypt', // 解析提示跳过，增加强制结束
        },
      })
      .then((data) => {
        if (data.code === 200) {
          commit('SETCLOSELOADING', true);  // 关闭开标结束loading
          if (payload.failBidderList && payload.failBidderList.length) {
            MessageBox({
              title: '提示',
              message: `有 ${payload.failBidderList.length} 家投标单位文件导入失败，失败的投标人不能进入评标环节，是否强制结束开标？`,
              showCancelButton: true,
              cancelButtonText: '取消',
              confirmButtonText: '确定',
              cancelButtonClass: 'confirmButton confirmButtonFailBid',
              confirmButtonClass: 'cancelButton',
              closeOnClickModal: false,
              closeOnPressEscape: false,
              distinguishCancelAndClose: true,
            })
              .then(() => {
                //是否需要确认流标(有效投标单位小于三家需要确认是否流标)
                dispatch('failBidsVisible');
              })
              .catch(() => {
                setTimeout(() => {
                  flagLoading = 0;
                }, 500);
              });
          } else {
            dispatch('failBidsVisible');
          }
        } else if (data.code === 4001) {
          commit('SETCLOSELOADING', true);  // 关闭开标结束loading
          MessageBox({
            title: '提示',
            message: data.msg,
            showCancelButton: true,
            cancelButtonText: '取消',
            confirmButtonText: '确认',
            cancelButtonClass: 'confirmButton confirmButtonFailBid',
            confirmButtonClass: 'cancelButton',
            closeOnClickModal: false,
            closeOnPressEscape: false,
            distinguishCancelAndClose: true,
          })
            .then(() => {
              window.sessionStorage.setItem(
                'curStage',
                JSON.parse(sessionStorage.getItem('currentMenuTrue')).stage
              );
              dispatch(
                'toolbar/getTendCtrlPriceInfo',
                {
                  visible: true,
                  bidSectionId: state.currentBidSection.bidSectionId,
                },
                { root: true }
              );
            })
            .catch(() => {});
          setTimeout(() => {
            flagLoading = 0;
          }, 500);
        } else {
          commit('SETCLOSELOADING', true);  // 关闭开标结束loading
          MessageBox({
            title: '提示',
            message: data.msg,
            confirmButtonText: '知道了',
          });
          setTimeout(() => {
            flagLoading = 0;
          }, 500);
        }
      })
      .catch(() => {
        commit('SETCLOSELOADING', true);  // 关闭开标结束loading
        setTimeout(() => {
          flagLoading = 0;
        }, 500);
      });
  },
  //检查异议是否完成
  checkDissentFinish({ dispatch,commit }) {
    service
      .get('/openbidFinish/checkDissentFinish', {
        params: {
          openbidId: state.currentBidSection.openbidId,
        },
      })
      .then((data) => {
        commit('SETCLOSELOADING', true);  // 关闭开标结束loading
        if (data.code === 200) {
          //是否需要确认流标(有效投标单位小于三家需要确认是否流标)
          dispatch('failBidsVisible');
        } else {
          MessageBox({
            title: '提示',
            message: data.msg,
            confirmButtonText: '知道了',
          });
          setTimeout(() => {
            flagLoading = 0;
          }, 500);
        }
      })
      .catch(() => {
        commit('SETCLOSELOADING', true);  // 关闭开标结束loading
        setTimeout(() => {
          flagLoading = 0;
        }, 500);
      });
  },
  // 检测计算评标基准价是否完成
  checkEvaluBenchmarkPrice({ dispatch,commit }) {
    service
      .post('/openbidFinish/checkEvaluBenchmarkPrice', {
        bidSectionId: state.currentBidSection.bidSectionId,
        openbidId: state.currentBidSection.openbidId,
        projectId: state.currentBidSection.projectId,
      })
      .then((data) => {
        commit('SETCLOSELOADING', true);  // 关闭开标结束loading
        if (data.code === 200) {
          dispatch('checkOpenReportSign');
        } else {
          MessageBox({
            title: '提示',
            message: data.msg,
            showCancelButton: true,
            cancelButtonText: '取消',
            confirmButtonText: '确认',
            cancelButtonClass: 'confirmButton confirmButtonFailBid',
            confirmButtonClass: 'cancelButton',
            closeOnClickModal: false,
            closeOnPressEscape: false,
            distinguishCancelAndClose: true,
          })
            .then(() => {
              // 自动打开计算并宣布评标基准价页面、
              router.push('/index/bidPrice');
              // 定位导航选中
              let array = JSON.parse(sessionStorage.getItem('menuTrue')) || [];
              array.forEach((item, index) => {
                if (item.url === '/index/bidPrice') {
                  for (
                    let i = 0;
                    i < document.querySelectorAll('.el-menu-item').length;
                    i++
                  ) {
                    if (i == index) {
                      document
                        .querySelectorAll('.el-menu-item')
                        [i].classList.add('is-active');
                    } else {
                      document
                        .querySelectorAll('.el-menu-item')
                        [i].classList.remove('is-active');
                    }
                  }
                }
              });
            })
            .catch(() => {
              //取消
            });
        }
      });
  },
  //开标结束接口
  doOpenBidFinish({ state, dispatch ,commit}) {
    commit('SETCLOSELOADING', false);  // 关闭开标结束loading
    service
      .post('/openbidFinish/doOpenBidFinish', {
        bidResult: state.currentBidSection.bidResult,
        bidSectionId: state.currentBidSection.bidSectionId,
        finishRemark: state.currentBidSection.finishRemark,
        openbidId: state.currentBidSection.openbidId,
        projectId: state.currentBidSection.projectId,
        faildReason: state.currentBidSection.faildReason,
        userId: JSON.parse(window.sessionStorage.getItem('obj')).userId,
      })
      .then((res) => {
        commit('SETCLOSELOADING', true);  // 关闭开标结束loading
        if (res.code === 200) {
          dispatch('getOpenBidFinishInfo');
          // MessageBox({
          //   title: '提示',
          //   message: '开标结束成功',
          //   confirmButtonText: '确认'
          // });
        } else {
          MessageBox({
            title: '提示',
            message: res.msg,
            confirmButtonText: '知道了',
          });
        }
      });
  },
  // 开标结果
  handleKbjg({ dispatch }) {
    service
      .get('/openBid/info/getOpenbidStage', {
        params: {
          domainId:
            sessionStorage.getItem('row') &&
            JSON.parse(sessionStorage.getItem('row'))[0].domainId,
        },
      })
      .then(({ data, code, msg }) => {
        if (code === 200) {
          sessionStorage.setItem('openbidStage', data);
          if (!document.querySelector('.open-file-class')) {
            dispatch('getListAll');
          }
        } else {
          Message({ message: msg, type: 'error' });
        }
      });
  },
  // 获取开标报表
  getListAll() {
    let wid =
      parseFloat(
        window.getComputedStyle(document.querySelector('#app')).width
      ) - 88;
    let hei =
      parseFloat(
        window.getComputedStyle(document.querySelector('#app')).height
      ) - 120;
      layer.open({
       type: 2,
       skin: 'open-file-class',
       title: '开标结果',
       shadeClose: false,
       shade: 0,
       offset: 'auto',
       resize: false,
       area: [wid + 'px', hei + 'px'],
       maxmin: false,
       content: LAYER_URL + 'openResult',
       moveOut: true,
       moveEnd: function (layero) {
         const w = parseInt(layero[0].style.width);
         const h = parseInt(layero[0].style.height);
         if (parseInt(layero[0].style.top) < 0) {
           layero[0].style.top = '0px';
         }
         if (parseInt(layero[0].style.left) < -w + 200) {
           console.log('left');
           layero[0].style.left = -w + 160 + 'px';
         }
         if (parseInt(layero[0].style.left) > w) {
           layero[0].style.left = w + 'px';
         }
         if (parseInt(layero[0].style.top) > h) {
           layero[0].style.top = h + 100 + 'px';
         }
       },
      });
  },
};
const mutations = {
  USERINFO(state, payload) {
    state.userInfo = payload;
  },
  LIST(state, payload) {
    state.list = payload;
  },
  ISFAILBID(state, payload) {
    state.isFailBid = payload;
  },
  CRDIALOVISIBLEG(state, payload) {
    state.crDialogVisible = payload;
  },
  FAILDREASON(state, payload) {
    state.faildReason = payload;
  },
  CURRENTBIDSECTION(state, payload) {
    state.currentBidSection = payload;
  },
  SETCLOSELOADING(state, payload) {
    state.isCloseEndLoading = payload;
  },
};

export default {
  namespaced: true,
  modules: {
    toolbar,
  },
  state,
  getters,
  actions,
  mutations,
};
